import { PrincipalMapper } from '../mappers/PrincipalMapper';
import { Module } from '../Module';
import { GetPrincipalNamesRequest, IGetPrincipalNamesResult } from '../ServerApi/requests/GetPrincipalNamesRequest';
import { IPrincipal } from '../ServerApi/types/IPrincipal';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class PrincipalNames extends Resource<IPrincipal> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetPrincipalNamesRequest,
      (result: IGetPrincipalNamesResult) => PrincipalMapper.map(result)));
  }

}

Module.instance().service('PrincipalNames', PrincipalNames);
